export default __webpack_public_path__ + "static/2-1--58aa15d9be5951d7b88fdb43c70a908e.png";